import {action, computed, observable, runInAction, when, axios, React, IReactionDisposer} from '@api'
import {BuilderCardWithPopoverContainer, CatalogItemsCardViewRowProps, CatalogItemsCardViewStore, DEBUG_CATALOG_ITEM_CARDS} from '@modules'
import * as css from '@modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_CatalogItems/CardView/LoadMoreProductCatalog/CatalogItemsCardView.css'
import {StoresInstance} from '@stores/StoresInstance'
import {ui} from '@stores/ui'
import {authStore} from '@utils'
import {CancelTokenSource} from 'axios'
// import {IReactionDisposer} from 'mobx/lib/internal'
import {useContext} from 'react'
import {VipLocalStore} from '@modules'

export class ProductsVirtualRowStore extends VipLocalStore {
  constructor(stores: StoresInstance,public props: CatalogItemsCardViewRowProps, public store: CatalogItemsCardViewStore) {
    super(stores)
    // console.log(`Create store for `, props.index)
    store.virtualRowStore[props.index] = this
  }

  @observable.ref error
  @observable.ref lastSearchPayload

  /**
   * {@see CatalogItemsCardViewStore.registerEffects}
   */
  registerEffects = () => {
    const {catalog} = this
    const toDispose = [
      when(() => catalog.hasFinishedFirstLoad && _.values(catalog.seasonSelectorsCatalog).every(ss => !ss.filterGroupStore.initialLoad), () => {
        const {catalog: {_sourceDynamic, refetchId}, props: {queryVariables}} = this
        this.runQuery({_sourceDynamic, queryVariables, refetchId})
      })
    ]


    /*if (catalog.index && !this.props.groupStore) {
      this.runQuery()
    }*/

    // Handle these at the top level to clear these rows
    /*autorun(async () => {
      if (catalog?.index) {
        const {searchPayload} = this
        // console.log(`autorun - runSearch`)
        //trace()
        runInAction(async () => {
          if (!_.isEqual(this.searchPayload, this.lastSearchPayload)) {
            this.lastSearchPayload = this.searchPayload
            await this.runQuery()
          }
          else {
            DEBUG && console.log(`Skipping query as search payload has not changed`)
          }
        })
      }
    }, {name: `Run product virtual row query ${this.props.groupStore?.props?.info?.key ?? catalog.index} - row ${this.props.index}`}),
    reaction(() => ({refetchId: catalog.refetchId}), () => this.runQuery())
  ]*/
    return () => toDispose.forEach(f => f())
  }

  /*
   const {error} = useAsync(async () => {
    if (!catalog.loadingCounts) {
      return await search()
    }
    return null
  }, [onlineItemCount, searchPayload, refetchId, catalog.loadingCounts])

   */
  @computed get showLoadMoreButton() {
    const {catalog, store: {hasMore, isLoadingMore, groupNode}, props: {index}, catalog: {settings: {showOnlyOfflineItems, showOnlyInlineCatalogItems, showOnlyItemsWithChanges}}} = this
    return !showOnlyOfflineItems && !showOnlyItemsWithChanges && !showOnlyInlineCatalogItems && !groupNode?.store?.settings?.showOnlyOfflineItems && ((this.props.index + 1 === this.store.timesClicked && (hasMore || isLoadingMore)) ?? (index != 0 || catalog.isProductView)) // We already have a loader in our group header, don't show the button for the
    // initial load
  }

  @computed get searchSize() {
    const {props: {onlineItemCount, index}, store: {catalog, itemsPerClick}} = this,
      {itemCount, filteredOfflineItems} = catalog

    let r = Math.min(itemsPerClick, (itemCount - filteredOfflineItems?.length) ?? onlineItemCount ?? itemsPerClick)

    if (_.isNaN(r) || !_.isNumber(r)) return ui.settings.defaults.catalog.cardsPerVirtualRow

    // // One the last row, only ask for
    // if (onlineItemCount && index + 1 === onlineItemCount / itemsPerClick) {
    //   return onlineItemCount % itemsPerClick
    // }

    return r
  }

  @computed.struct get searchPayload() {
    const {props: {queryVariables, _source, index}, store: {catalog, itemsPerClick}, searchSize} = this

    let r = {...queryVariables}
      //extraSize = showInlineCatalogItemsFirst ? catalog.localLODCatalogItems.length : 0

    // If we modify the search payload it will force a full reload, instead get the expanded items separately in the future
    // if (showInlineCatalogItemsFirst && catalog.localLODCatalogItems.length) {
    //   r = {
    //     ...r,
    //     query: {
    //       ...r.query,
    //       bool: {
    //         ...r.query.bool,
    //         ...catalog.es.myShouldTermForInlineItemsFirst
    //       }
    //     }
    //   }
    // }
    return {
      ...r,
      ...(_source || catalog._sourceDynamic),
      size: (searchSize ?? 0),
      from: (itemsPerClick * index)
      //"script_fields": {"firstImage": {"script": {"lang": "painless", "source": "params['_source'].images.stream().findFirst().orElse(null)"}}},
      // There are numerous images on the object but we only need to show the first one in the GUI so select only that one
      // Only get the raw data on the first load
      // 'script_fields': this.isFirstQuery ?
      //   {'firstImage': {'script': {'lang': 'painless', 'source': `def d = params['_source'].images.stream().findFirst().orElse(null);  return d != null ? d['${levelOfDetail == 0  || true // too expensive to get all images
      //                                                                                                                                                          ? 'thumbnailImageRaw' : 'smallImageRaw'}'] : d`}}} :
      //                  undefined
    }
  }

  @observable isFirstQuery = true
  @observable hasLoadedResult = false
  @observable.ref searchCancelToken: CancelTokenSource
  @observable isRefetchChange = false

  _last: {_sourceDynamic: { _source: string[] }, queryVariables: any, refetchId?: string}

  waitingToLoadProductsUntilGroupToOurLeftIsDone: IReactionDisposer
  @action runQuery = async (deps: { _sourceDynamic: {_source: string[]}, queryVariables: any, refetchId?: string }) => {
    if (!authStore.userIsAuthenticated) return

    // if (_.isEqual(this._last, deps)) {
    //   console.debug(`Ignored catalog items query request due to no detected change`, this.props.index)
    //   return
    // }

    if (this.props.groupStore?.shouldWaitToLoadProducts) {
      // console.log(`Waiting to load products until group to our left finishes`)
      this.waitingToLoadProductsUntilGroupToOurLeftIsDone?.()
      this.waitingToLoadProductsUntilGroupToOurLeftIsDone = when(() => !this.props.groupStore?.shouldWaitToLoadProducts, () => this.runQuery(deps))
    }

    // console.log(`Run virtual row query`, {isFirstQuery: this.isFirstQuery, deps})

    this.isRefetchChange = this._last != null && this._last?.refetchId !== deps.refetchId
    this._last = deps

    const {catalog, es, searchPayload, onCatalogItemsLoaded, props: {esIndex, index, groupStore}} = this

    if (groupStore?.grouping?.isOfflineGroup && groupStore?.props.info.key === true) {
      this.isFirstQuery = false
      this.loading = false
      return
    }

    if (this.loading && !this.isFirstQuery) { // Already awaiting a result
      if (this.searchCancelToken) {
        this.searchCancelToken.cancel(`Cancel catalog items virtual row query index ${index}`)
      }
    }

    // console.log(`Loading cards for index ${index}`, {searchPayload})
    this.loading = true
    this.searchCancelToken = axios.CancelToken.source()
    this.error = null
    this.isFirstQuery = false

    // console.debug(`Loading catalog item rows - `, {index, ..._.pick(searchPayload, ['size', 'from'])})

    try {
      const {hits} = await es.search(
        {
          meta: `${this.props.queryKey ?? ''} ${groupStore?.props?.info?.key ?? catalog.catalogItemName ?? ''} - LoadMoreProductsVirtualRowStore.search(${index})`,
          cancelToken: this.searchCancelToken.token,
          body: searchPayload,
          index: esIndex ?? catalog.index
        },
        {
          log: {query: DEBUG_CATALOG_ITEM_CARDS, result: false}
        })

      // console.log(`Finished loading ${index}`, hits)
      return hits?.hits && runInAction(`Loaded virtual row for catalog items - index: ${index}`, () => {
        this.hasLoadedResult = true
        return onCatalogItemsLoaded(hits.hits)
      })
    } catch (err) {
      if (!axios.isCancel(err)) {
        console.error(err)
        this.error = err
      }
    } finally {
      this.loading = false
      // if (catalog.isProductView) {
      //   catalog.updateLoadingState(({loading: false}))
      // }
    }
  }

  @action private onCatalogItemsLoaded = (data) => {
    const {catalog: {mapCatalogItemResults, selection: {clearInvalidCatalogItemSelections}}, store, store: {loadingIndex, timesClicked}, props: {index}} = this,
      items = mapCatalogItemResults(data)

    if (index == loadingIndex) {
      store.loadingIndex = timesClicked == loadingIndex + 1 ? -1 : loadingIndex + 1
    }
    //console.log(items)

    // Avoid looping the result set twice
    const itemWrappers = []

    itemWrappers.push(...items)

    this.setItemWrappers(itemWrappers)

    this.loading = false

    if (index + 1 == store.timesClicked) {
      store.sharedId++
    }

    clearInvalidCatalogItemSelections()
    store.initialDataLoaded = true
    store.everLoadedData = true
    return items
  }

  @computed get itemWrappers() {
    const {catalog, keyIndex, props: {groupStore}} = this
    return groupStore ? groupStore.catalogItemsByGroup.get(keyIndex) : catalog.itemWrappers.get(keyIndex)
  }

  @computed get keyIndex() {
    const {props: {index, queryKey, esIndex}} = this
    return `${esIndex} - ${queryKey} - ${index}`
  }

  setItemWrappers = (val) => {
    const {catalog, keyIndex, props: { groupStore}} = this
    if (groupStore) {
      groupStore.catalogItemsByGroup.set(keyIndex, val)
    } else {
      catalog.itemWrappers.set(keyIndex, val)
    }
  }

  @observable loading = true

  get groupStore() { return this.props.groupStore}

  @computed get perspective() {
    const {groupStore, catalog, store} = this
    if (store?.props?.assortment?.selectedPerspective) {
      return store.props.assortment.selectedPerspective
    }
    if (groupStore?.settings?.perspective) {
      return catalog.perspectivesById[groupStore.settings.perspective]
    } else {
      return catalog.perspective
    }
  }

  @computed get productCardProps() {
    const {catalog: {_fieldByName, index: catalogIndex, workspaceByIndex}, perspective} = this,
      {props: {onClickProduct, path}, store} = this,
      index = (perspective?.field ? _fieldByName[perspective.field]?.esIndex : catalogIndex) ?? catalogIndex

    return {
      onClickProduct,
      path,
      type: index,
      workspace: workspaceByIndex[index],
      visibleCardFields: store?.props?.assortment?.visibleCardFields
    }
  }

  @computed get childrenCards() {
    // trace()
    const {
        props: {offline, index, itemsPerClick}, groupStore, productCardProps, perspective, catalog, store, itemWrappers, isRefetchChange, loading,
        catalog: {settings: {showOnlyItemsWithChanges}}, filter: {offlineFilter}, es, filter
      } = this,
      perspectiveFieldName = store?.props?.assortment?.selectedPerspective?.field ?? perspective?.field,
      perspectiveField = perspectiveFieldName ? catalog._fieldByName[perspectiveFieldName] : null

    // if ((groupStore?.settings?.showOnlyOfflineItems || showOnlyOfflineItems) && !offline) return []
    // if (groupStore?.settings?.showOnlyOnlineItems && offline) return []
    if (!offline && offlineFilter && offlineFilter.selected.has('offline') && !offlineFilter.selected.has('online')) return []

    let items = itemWrappers
    if (showOnlyItemsWithChanges) {
      items = items.filter(item => catalog.catalogItemsWithUnsavedChangesMap[item._id])
    }

    const flattened = _.flatMap<{ key: string, item?: any, extraCardProps? }>(
        items.map((item, i) => {
          if (!perspectiveField) {
            return {item, key: `${item._id}_${i}`, index: (index * itemsPerClick) + i, extraCardProps: {index: i}}
          } else {
            // Transform the nested field (which may be an array) into a new set of card(s)
            const {val: nestedObject} = es.readField(item, perspectiveFieldName, null, {noString: true})

            // We don't want to have to convert all the existing complex things like style -> colorway to nested types in ES yet, so when user does something like filter active colorway = true, we do that filtering here for now - TODO PERF
            const arr = _.uniqBy(
              filter.filterNested(perspectiveFieldName, (_.isArray(nestedObject) ? nestedObject : [nestedObject]), groupStore/*, perspective*/),
              r => catalog.idFor(r)
            )

            // DEBUG && console.debug(`Nested items for `, item, {perspectiveFieldName, arr})

            const r = !nestedObject ? [] : arr.map((nestedObject, j) => {

              if (!perspectiveField.esIndex) {
                return {key: `${item._id}-${nestedObject?._id ?? nestedObject?.exId ?? nestedObject?.id}-${j}`, item: null}
              } else {
                return {
                  key: `${item._id}-${nestedObject?._id ?? nestedObject?.exId ?? nestedObject?.id}-${j}`,
                  item: nestedObject,
                  extraCardProps: {index: i, nested: {field: perspectiveField, parentData: item, data: nestedObject, arrayIndex: j}}
                }
              }
            })

            return r
          }
        })
      ).filter(_.identity),
      uniq = _.uniqBy(flattened, v => catalog.idFor(v.item, false))

    const r = true ?
              uniq.map(({key, item, extraCardProps}, i) => (
                !item
                ? <div className={css.noNested} key={i}/>
                : (
                  <BuilderCardWithPopoverContainer
                    key={key}
                    item={item}
                    data-index={extraCardProps?.index}
                    data-internal-index={i}
                    data-is-refetch={isRefetchChange === true}
                    data-loading-data={loading === true}
                    data-virtual-row-index={index}
                    productCardProps={productCardProps}
                    extraCardProps={extraCardProps}/>
                )))
                   : _.flatMap(
        items.map((item, i) => {
          const catalogItemCard = <BuilderCardWithPopoverContainer
            key={`${item._id}_${i}`}
            data-index={(index * itemsPerClick) + i}
            data-internal-index={i}
            data-loading-data={loading === true}
            data-virtual-row-index={index}
            {...{
              item,
              productCardProps,
              extraCardProps: {index: i}
            }}/>

          if (!perspectiveField) {
            return catalogItemCard
          } else {
            // Transform the nested field (which may be an array) into a new set of card(s)

            const {val: nestedObject, valAsString} = es.readField(item, perspectiveFieldName)

            // We don't want to have to convert all the existing complex things like style -> colorway to nested types in ES yet, so when user does something like filter active colorway = true, we do that filtering here for now - TODO PERF
            const arr = _.uniqBy(
              filter.filterNested(perspectiveFieldName, (_.isArray(nestedObject) ? nestedObject : [nestedObject]), groupStore/*, perspective*/),
              r => catalog.idFor(r)
            )

            //DEBUG && console.debug(`Nested items for `, item, {perspectiveFieldName, arr})

            const r = !nestedObject
                      ? <div className={css.noNested} key={i} data-id={item._id}>
                        {/*No {perspective.label} for {boardItem.subtitle1 ?? boardItem.title*/}
                        {false && catalogItemCard}
                      </div>
                      : arr.map((nestedObject, j) => {

                if (!perspectiveField.esIndex) {
                  return <div className={css.nonCatalogItem}>
                    {valAsString}
                  </div>
                }

                const builderCardProps = {
                  item: nestedObject,
                  productCardProps,
                  extraCardProps: {index: i, nested: {field: perspectiveField, parentData: item, data: nestedObject, arrayIndex: j}}
                }

                // Generate a new synthetic version with only this instance of the item:
                return <BuilderCardWithPopoverContainer
                  key={`${item._id}-${nestedObject?._id ?? nestedObject?.exId ?? nestedObject?.id}-${j}`}
                  data-index={j}
                  {...builderCardProps}/>
              })

            return r
          }

          return null
        })).filter(_.identity)

    //DEBUG && perspectiveField && console.debug(`Nested items for ${index} - ${perspectiveField?.field} `, {in: toJS(items), out: r})

    // if (_.isEmpty(r)) {
    //   return [<div key={'empty_filter_html'}>All {pluralize(perspective.label)} have been filtered by your view options.</div>]
    // }

    return r
  }
}

//region Context
export const LoadMoreProductsVirtualRowStoreContext = React.createContext<ProductsVirtualRowStore>(undefined)
export const useLoadMoreProductsVirtualRowStore = () => useContext(LoadMoreProductsVirtualRowStoreContext)
//endregion



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_CatalogItems/CardView/LoadMoreProductCatalog/ProductsVirtualRowStore.tsx